export const cartKey = (s) => `zylo_cart_${s}`;
export const wishKey = (s) => `zylo_wish_${s}`;

export const getCart = (s) => { try { return JSON.parse(localStorage.getItem(cartKey(s)) || "[]"); } catch { return []; } };
export const saveCart = (s, c) => localStorage.setItem(cartKey(s), JSON.stringify(c));
export const getWish = (s) => { try { return JSON.parse(localStorage.getItem(wishKey(s)) || "[]"); } catch { return []; } };
export const saveWish = (s, w) => localStorage.setItem(wishKey(s), JSON.stringify(w));

export const addItem = (cart, p, qty = 1, variation = "", overrides = {}) => {
  const key = p.id + "|" + variation;
  const ex = cart.find((c) => c.key === key);
  if (ex) return cart.map((c) => (c.key === key ? { ...c, qty: c.qty + qty } : c));
  return [...cart, { key, product_id: p.id, name: p.name, price: overrides.price ?? p.price, image: overrides.image ?? p.images?.[0] ?? "", qty, variation }];
};

export const cartCount = (cart) => cart.reduce((s, c) => s + c.qty, 0);
export const cartSubtotal = (cart) => cart.reduce((s, c) => s + c.price * c.qty, 0);

export const discountPct = (p) =>
  p.compare_price && p.compare_price > p.price ? Math.round((1 - p.price / p.compare_price) * 100) : 0;
